<script setup>
import { ref, onMounted, computed } from 'vue'
import {getUser, updateUser} from '@/services/api/auth.js'
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import {handleLoginError} from "@/utils/errors.js";
import messageService from '@/services/messages.js'
import {useI18n} from "vue-i18n";
import router from "@/router/index.js";
import EmailField from "@/components/authentication/fields/EmailField.vue";
import InputText from "@/components/common/fields/InputText.vue";
import Select from "@/components/common/fields/Select.vue";

const user = ref(null)
const { t } = useI18n()
const loading = ref(false)
const originalUser = ref({});
const form = ref(null);

onMounted(() => {
    user.value = getUser()
    originalUser.value = { ...user.value };
});

const hasChanges = computed(() => {
    return (
       user.value.fullname !== originalUser.value.fullname ||
       user.value.email !== originalUser.value.email
    );
});
const handleAccountDetail = async () => {
    try {
        const { valid } = await form.value.validate()
        if (!valid) return
        loading.value = true;

        const logout = user.value.email !== getUser().email;

        const response = await updateUser({
            id: user.value.id,
            name: user.value.fullname,
            email: user.value.email,
        });


        if (logout) {
            messageService.success(t('components.myProfile.accountDetails.emailUpdatedReLogin'))
            return router.push('/logout');
        }
        messageService.success(t('common.messages.success.save'))
        loading.value = false;
        user.value = getUser()
        originalUser.value = { ...user.value };
    } catch (error) {
        loading.value = false;
        await handleLoginError(error, t);
    }
};

</script>

<template>
    <div class="account-settings-card" v-if="user">
        <v-form ref="form"  @submit.prevent="handleAccountDetail">
            <div class="row">
                <div class="col-sm-6">
                    <div class="trezo-form-group">
                        <v-label class="main-label d-block fw-medium text-black">
                            {{ $t('components.myProfile.accountDetails.fullName') }}
                        </v-label>
                        <InputText
                            :label="$t('components.myProfile.accountDetails.fullName')"
                            v-model="user.fullname"
                        ></InputText>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="trezo-form-group">
                        <v-label class="main-label d-block fw-medium text-black">
                            {{ $t('components.myProfile.accountDetails.username') }}
                        </v-label>
                        <InputText
                            :label="$t('components.myProfile.accountDetails.username')"
                            v-model="user.username"
                            class="input-disabled"
                            readonly
                        ></InputText>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="trezo-form-group">
                        <v-label class="main-label d-block fw-medium text-black text-disabled">
                            {{ $t('components.myProfile.accountDetails.emailAddress') }}
                        </v-label>
                        <EmailField v-model="user.email" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="trezo-form-group">
                        <v-label class="main-label d-block fw-medium text-black text-disabled">
                            {{ $t('components.users.userCreate.permissionGroup') }}
                        </v-label>
                    </div>
                    <Select :clearable="false" class="input-disabled" readonly v-model="user.workgroups" multiple chips item-title="name" item-value="id" maxlength="150" items=""/>
                </div>
                <div class="form-btn-box">
                    <ButtonSave :loading="loading" :disabled="!hasChanges"   />
                </div>
            </div>
        </v-form>
    </div>
</template>

<style lang="scss" scoped>
.account-settings-card {
    h5 {
        margin-bottom: 7px;
    }
    p {
        margin-bottom: 25px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .account-settings-card {
        p {
            margin-bottom: 17px;
        }
    }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
    .account-settings-card {
        p {
            margin-bottom: 20px;
        }
    }
}
</style>
